import type * as React from 'react';

export function CustomCircleTickIcon({
    size = 24,
    color = 'currentColor',
    strokeWidth = 1.5,
    className,
    ...props
}: React.SVGProps<SVGSVGElement> & {
    size?: number;
    color?: string;
    strokeWidth?: number;
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...props}
        >
            <path
                d="M8.00061 0.99998C9.85695 1.0001 11.63765 1.73811 12.9503 3.05075C14.26271 4.36346 14.99988 6.14417 14.99988 8.00046C14.99975 9.8568 14.26296 11.63752 12.9503 12.95018C11.63765 14.26283 9.85695 14.99963 8.00061 14.99975C6.14432 14.99975 4.36361 14.26258 3.0509 12.95018C1.73826 11.63752 1.00025 9.8568 1.00012 8.00046C1.00012 6.14393 1.73815 4.36351 3.0509 3.05075C4.36365 1.738 6.1441 0.99998 8.00061 0.99998ZM11.12336 4.09974L10.96007 4.11789C10.7974 4.14363 10.63943 4.19276 10.49175 4.26428L10.34781 4.34413C10.16082 4.45873 9.99771 4.60842 9.86869 4.78575L7.05447 8.6538L5.9716 7.57094H5.97281C5.85703 7.45118 5.72365 7.3499 5.57838 7.26967L5.42956 7.19708L5.27349 7.139C5.16792 7.10566 5.05931 7.08314 4.94924 7.07125L4.78348 7.06157C4.61691 7.0602 4.45132 7.08316 4.29225 7.13054L4.13619 7.18619C3.98188 7.24941 3.83756 7.33491 3.70909 7.44027L3.58689 7.55158C3.46909 7.66949 3.36939 7.80411 3.29168 7.95085L3.2215 8.10087C3.13749 8.30646 3.09485 8.5273 3.09688 8.74938C3.09896 8.97129 3.14593 9.1904 3.23359 9.39426C3.31903 9.59289 3.44264 9.77251 3.59657 9.92419V9.92541L6.07444 12.40331C6.24532 12.57428 6.45145 12.70673 6.67819 12.79048C6.90463 12.87398 7.14655 12.90719 7.38718 12.88848C7.62808 12.86965 7.86229 12.79828 8.0732 12.68034C8.23135 12.59188 8.37417 12.47876 8.49545 12.3452L8.6104 12.20483L12.57404 6.75305H12.57527C12.70425 6.57538 12.79618 6.37368 12.84747 6.16019C12.88588 5.99995 12.90074 5.83533 12.89108 5.67139L12.87411 5.50806L12.84016 5.34714C12.81253 5.24121 12.77425 5.13834 12.72642 5.03983L12.64788 4.89585L12.55471 4.76034C12.48867 4.6732 12.41496 4.5922 12.33331 4.51958L12.20496 4.41673L12.06706 4.32599C11.97265 4.27068 11.8728 4.22512 11.76947 4.18926L11.61212 4.14328L11.45007 4.11304C11.34179 4.09811 11.23239 4.09333 11.12336 4.09974Z"
                fill={color}
                stroke={color}
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}
